import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ToxOffering from "@/pages/ToxOffering";

export const Route = createFileRoute("/en/services/regulatory-toxicology/environmental-risk-assessment-era")({
  head: () => buildRouteHead("/en/services/regulatory-toxicology/environmental-risk-assessment-era"),
  component: ToxOffering,
});

